<template>
  <div v-if="message" class="modal-frame active order-message-required">
    <div class="modal-frame-content" role="alertdialog" aria-modal="true">
      <div class="modal-frame-header"><div class="h3">{{ t('orderMessages.unreadTitle') }}</div></div>
      <div class="modal-frame-body order-message-required__body">
        <p class="font-16 order-message-required__text">{{ message.text }}</p>
        <p class="muted-14 order-message-required__order">
          {{ t('orderMessages.order') }}:
          <router-link :to="`/order/${message.order.id}/`">{{ message.order.number || message.order.invoice || message.order.id }}</router-link>
        </p>
        <p class="muted-14 order-message-required__date">{{ formatDate(message.created_at) }}</p>
        <div v-if="error" class="mc-error">{{ error }}</div>
      </div>
      <div class="flex-center">
        <button class="btn" type="button" :class="{loader: acknowledging}" :disabled="acknowledging" @click="acknowledge">
          {{ t('orderMessages.acknowledge') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {useI18n} from 'vue-i18n';

export default {
  data: () => ({message: null, count: 0, loading: false, acknowledging: false, timer: null, error: ''}),
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
  mounted() {
    this.load();
    this.timer = window.setInterval(this.load, 45000);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeUnmount() {
    window.clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    async load() {
      if (this.loading || this.acknowledging) return;
      this.loading = true;
      try {
        const response = await axios.get('/api/order/messages/unread/');
        if (response.data.status !== 'error') {
          this.message = response.data.data.message || null;
          this.count = response.data.data.count || 0;
          this.error = '';
        }
      } catch (error) {
        // Keep the current mandatory message visible and retry on the next poll.
      } finally {
        this.loading = false;
      }
    },
    async acknowledge() {
      if (!this.message || this.acknowledging) return;
      this.acknowledging = true;
      this.error = '';
      let acknowledged = false;
      try {
        const response = await axios.post(`/api/order/message/${this.message.id}/read/`);
        if (response.data.status === 'error') throw new Error(response.data.errors?.[0]?.message);
        this.message = null;
        acknowledged = true;
      } catch (error) {
        this.error = error.message || this.t('orderMessages.acknowledgeError');
      } finally {
        this.acknowledging = false;
      }
      if (acknowledged) await this.load();
    },
    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.load();
    },
    formatDate(value) {
      return value ? new Intl.DateTimeFormat(this.locale, {dateStyle: 'short', timeStyle: 'short'}).format(new Date(value)) : '';
    },
  },
};
</script>

<style scoped>
.order-message-required { z-index: 2000; }
.order-message-required__body { min-width: 420px; }
.order-message-required__text { margin: 0 0 24px; line-height: 1.5; white-space: pre-wrap; overflow-wrap: anywhere; }
.order-message-required__order { margin: 0 0 14px; }
.order-message-required__date { margin: 0; }

@media (max-width: 575px) {
  .order-message-required__body { min-width: 0; }
}
</style>
